var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsdownicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#E63511"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2206 8.96798L11.2882 8.96798C11.6813 8.96798 12 8.645 12 8.24653L12 5.72145C12 5.32301 11.6813 4.99999 11.2882 4.99999L10.2206 4.99999M10.2206 8.96798L9.08124 11.5663C8.9235 11.9261 8.50003 12.112 8.15661 11.928C7.62216 11.6418 7.72937 11.3735 7.72937 9.68944L5.71193 9.68944C5.27569 9.68944 4.9421 9.29532 5.00843 8.85829L5.50119 5.61176C5.5546 5.2598 5.85336 4.99999 6.2047 4.99999L10.2206 4.99999L10.2206 8.96798ZM10.2206 8.96798L10.2206 4.99999L10.2206 8.96798Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsdownicon);
export default __webpack_public_path__ + "static/media/thumbsdownicon.5ce96f88d8f101b8d5596d079898cf07.svg";
export { ForwardRef as ReactComponent };